<template>
  <el-container class="list_main_content">
    <el-aside width="200px" v-if="!$route.meta.single" v-show="asideShow">
      <p class="flow_tree_top_title">待阅事项分类</p>
      <FlowTree
        ref="FlowTree"
        @currentTree="getCurrent"
        :loadCount="loadCount"
      ></FlowTree>
    </el-aside>
    <div
      class="navbar-collapse"
      :class="{ 'navbar-collapse-right': !asideShow }"
      :style="navbarCollapseStyle"
      @click="asideShow = !asideShow"
    >
      <div class="navbar-collapse-bg" style="display: none;">
        <i
          class="navbar-collapse-arrow"
          :class="{
            'el-icon-arrow-left': asideShow,
            'el-icon-arrow-right': !asideShow,
          }"
        ></i>
      </div>
    </div>
    <el-container  :style="conheight">
      <collapse-search>
      <el-row style="margin:0 20px" >
        <el-col :span="8" class="search_form_container">
          <p class="search_form_label">工单号</p>
          <el-input v-model="searchForm['bpm_pro_inst.work_order_no']" class="search_input" clearable placeholder="请输入工单号"></el-input>
        </el-col>
        <el-col :span="8" class="search_form_container">
          <p class="search_form_label">流程事项</p>
          <el-input v-model="searchForm['bpm_pro_inst.subject_']" class="search_input" clearable placeholder="请输入流程事项"></el-input>
        </el-col>
        <el-col :span="8" class="search_form_container">
          <p class="search_form_label">流程名称</p>
          <el-input v-model="searchForm['bpm_pro_inst.proc_def_name_']" class="search_input" clearable placeholder="请输入流程名称"></el-input>
        </el-col>
          <el-col :span="8" class="search_form_container">
          <p class="search_form_label">传阅人</p>
          <el-input v-model="searchForm['bpm_task_notice.owner_name_']" class="search_input" clearable placeholder="请输入传阅人"></el-input>
        </el-col>
        <el-col :span="8" class="search_form_container">
          <p class="search_form_label">状态</p>
          <el-select v-model="searchForm['bpm_task_notice.IS_READ_']" class="search_input" clearable placeholder="请选择状态">
            <el-option key="" label="全部" value=""></el-option>
            <el-option key="0" label="待阅" value="0"></el-option>
            <el-option key="1" label="已阅" value="1"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="search_form_container">
          <p class="search_form_label">发起时间</p>
          <el-date-picker
            v-model="searchForm['bpm_pro_inst.create_time_']"
            type="datetimerange"
            align="right"
            size="small"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="search_input"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="8" class="search_form_container">
          <p class="search_form_label">到达时间</p>
          <el-date-picker
            v-model="searchForm['bpm_task_notice.create_time_']"
            type="datetimerange"
            align="right"
            size="small"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="search_input"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="8" class="search_form_container">
          <p class="search_form_label">阅读时间</p>
          <el-date-picker
            v-model="searchForm['bpm_task_notice.read_time_']"
            type="datetimerange"
            align="right"
            size="small"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="search_input"
          >
          </el-date-picker>
          
        </el-col>

        <el-col :span="8" class="search_form_container">
          <p class="search_form_label">申请人</p>
          <el-input v-model="searchForm['bpm_pro_inst.creator_']" class="search_input" clearable placeholder="请输入申请人"></el-input>
        </el-col>
      </el-row>
      <div class="content_top_wrap">
        <!-- <el-row class="done_read_btn">
          <el-button size="small" type="primary" @click="noticeTurnDode()">已阅</el-button>
        </el-row> -->
        <!-- <el-input
          size="small"
          clearable
          style="width:200px;"
          placeholder="流程事项/流程名称/工单号"
          prefix-icon="el-icon-search"
          v-model="tableData"
          @keyup.enter.native="searchEnterFun"
        ></el-input>
        
        <div class="date_wrap">
          <p>到达时间</p>
          <el-date-picker
            v-model="date"
            type="datetimerange"
            align="right"
            size="small"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </div> -->
        <el-row style="padding:8px 0px 8px 0px;">
          <el-col :span="24">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search('find')"
              >查询</el-button
            >
            <el-button size="small" @click="reset" icon="el-icon-refresh" style="margin-left: 16px;"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </div>
      </collapse-search>
      <el-main class="todo_read_content">
        <!-- default-sort  排序 -->
        <el-table
          :data="rows"
          style="width: 100%;"
          header-cell-class-name="todo-header-row"
          :row-class-name="tableRowClass"
          size="medium"
          height="100%"
          border
          v-loading.fullscreen.lock="fullscreenLoading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="40"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="workOrderNo"
            width="120"
            align="left"
            label="工单号"
            sortable
          ></el-table-column>
          <el-table-column label="流程事项">
            <template slot-scope="scope">
              <span class="todo-subject" @click="handleRowClick(scope.row)">{{
                scope.row.subject
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="流程名称"
            align="left"
            width="90"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.procDefName }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            label="任务名称"
            align="left"
            width="85"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type == 'todo'">{{ scope.row.name }}</span>
              <span v-if="scope.row.type =='done'">{{scope.row.taskName}}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="ownerName"
            label="传阅人"
            align="left"
            width="120"
          >
            <template slot-scope="scope">
              <span>{{scope.row.ownerName}}</span>
            </template>
          </el-table-column>
          <el-table-column width="60" align="left" label="状态">
            <template slot-scope="scope">
              <el-badge v-if="scope.row.isRead != '1'" is-dot></el-badge>
              <el-badge v-else size="small" is-dot  type="info"></el-badge>
              <el-badge v-if="scope.row.isRead !='1'" size="small" >待阅</el-badge>
              <el-badge v-else size="small">已阅</el-badge>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="startTime" label="发起时间" align="left" width="135" sortable  ></el-table-column> -->
          <el-table-column
            prop="createTime"
            label="到达时间"
            align="left"
            width="180"
            sortable
          ><template slot-scope="scope"><span>{{scope.row.createTime}}</span></template>
          </el-table-column>
          <el-table-column  label="阅读时间" align="left" width="180" sortable  prop="readTime">
            <template slot-scope="scope">
              <span>{{scope.row.readTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
            align="left"
          >
            <template slot-scope="scope">
              <eipTop 
                @search="search"
                :currentRow="scope.row"
                topType=3
                showItem="one">
              </eipTop>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="45px;line-height: 45px;">
        <el-row>
          <div style="display: initial;max-height:32px;">
            <span style="padding-right:16px;font-size: 14px;font-family: PingFang SC-Regular, PingFang SC;font-weight: 400;color: #52535E;">已选 {{arrlen}}条</span>
            <el-button  size="small" @click="noticeTurnDode()">已阅</el-button>
          </div>
          <eipTop style="display:initial" @search="search" :topList="topList" topType=3 showItem="many"></eipTop>
          <div style="float: right;display: initial;max-height:32px;">
            <el-pagination
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
          
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import FlowTree from "@/components/flow/flowTree.vue";
import utils from "@/utils.js";
import process from "@/api/process";
import { Message } from "element-ui";
import eipTop from "@/components/eipControl/EipTop"
export default {
  name: "todoRead",
  components: {
    FlowTree,
    eipTop
  },
  props: {
    defKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      asideShow: false,
      arrlen:0,
      tableData: "",
      date: "",
      currentTree: "",
      fullscreenLoading: true,
      ids: "", //传阅任务id集合
      conheight:{ height:'' },
      searchForm:{},
      searchOperation:{
        EQUAL:[ "bpm_task_notice.IS_READ_"],
        LIKE: ["bpm_pro_inst.work_order_no","bpm_pro_inst.subject_", "bpm_pro_inst.proc_def_name_","bpm_task_notice.owner_name_"],
        BETWEEN: ["bpm_pro_inst.create_time_", "bpm_task_notice.create_time_","bpm_task_notice.read_time_" ]
      },
      topList:[]
    };
  },
  computed: mapState({
    navbarCollapseStyle: function() {
      if (this.asideShow) {
        return { left: "200px" };
      }
      return { left: "0px" };
    },
    rows: (state) => state.storeProcess.rows,
    pagination: (state) => state.storeProcess.pagination,
    total: (state) => state.storeProcess.total,
  }),
  methods: {
    //页面高度
    getHeight(){
      this.conheight.height = window.innerHeight - 112 + "px";
    },
    //批量勾选待阅流程执行已阅操作
    handleSelectionChange(val) {
      this.ids = "";
      this.arrlen = val.length;
      this.topList = [];
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          this.ids = this.ids + val[i].id + ",";
          let topRow = {gdh:val[i].workOrderNo,topnum:val[i].topnum?val[i].topnum:0};
          this.topList.push(topRow);
        }
        this.ids = this.ids.substring(0, this.ids.length - 1);
      }
    },
    noticeTurnDode() {
      if (this.ids != "") {
        this.$store
          .dispatch("storeProcess/noticeTurnDode", this.ids)
          .then(() => {
            this.search("find");
          });
      } else {
        Message.warning("请选择要阅读的任务");
      }
    },
    //Loading 加载中
    openFullScreen() {
      this.fullscreenLoading = true;
    },
    handleSizeChange: function(size) {
      //每页下拉显示数据
      this.$store.dispatch("storeProcess/setPaginationSize", size);
      this.search();
    },
    handleCurrentChange: function(currentPage) {
      //点击第几页
      this.$store.dispatch("storeProcess/setPaginationPageNum", currentPage);
      this.search();
    },
    //回车查询
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.search("find");
      }
    },
    // 查询
    search(str) {
      const currentUser = this.$store.state.user.currentUserDetail.user;
      this.openFullScreen();
      if (str == "find") {
        this.$store.dispatch("storeProcess/setPaginationPageNum", 1);
      }
      let queryFilter = {};
      let querys = this.getSearchQueries();
      let sorter = this.getSorter();
      queryFilter = { pageBean: this.pagination, querys ,sorter};
      debugger;
      this.$store
        .dispatch("storeProcess/getNoticeTodoReadList", queryFilter)
        .then(() => {
          this.fullscreenLoading = false;
        });
    },
    //重置
    reset() {
      this.$set(this, "searchForm",{})
      this.search("find");
    },
    handleRowClick(row) {
      //this.$router.push("/inst/" + row.procInstId + "/read/" + row.id);
      let token = this.$store.state.login.currentUser.token;
      let url = window.context.front;
      url += "/inst/" + row.procInstId + "/read/" + row.id;
      url += "?token=" + token;
      let winObjEI = window.open(
        url,
        "_blank",
        "width=" +
          (window.screen.availWidth - 10) +
          ",height=" +
          (window.screen.availHeight - 70)
      );
      let isClose = 1;
      let this_ = this;
      //关闭open页面时刷新父页面列表
      let loop = setInterval(function() {
        if (winObjEI.closed && isClose == 1) {
          isClose--;
          //这里写刷新代码
          this_.search("find");
          clearInterval(loop);
        }
      }, 1000);
    },
    //子组件传值父组件(待办分类查询)
    getCurrent(data) {
      if (data.id == 6) {
        this.openFullScreen();
        let pageBean = { pageBean: this.pagination };
        this.$store
          .dispatch("storeProcess/getNoticeTodoReadList", pageBean)
          .then(() => {
            this.fullscreenLoading = false;
          });
      } else {
        let ids = [];
        this.getFlowTrees(data, ids);
        this.currentTree = ids.join(",");
        this.search("find");
      }
    },
    getFlowTrees(data, ids) {
      ids.push(data.id);
      let arr = data.children;
      for (var i = 0; i < arr.length; i++) {
        this.getFlowTrees(arr[i], ids);
      }
    },
    loadCount() {
      return process.getNoticeTodoReadCount({});
    },
    getSearchQueries(){
      let queryies = [];
      if(this.currentTree){
        queryies.push({
          property: "bpm_pro_inst.type_id_",
          value: this.currentTree,
          group: "typeId",
          operation: "IN",
          relation: "AND",
        })
      }
      Object.keys(this.searchForm).forEach(key => {
        if(this.searchForm[key]){
          queryies.push({
            property:key,
            value: this.searchForm[key],
            group: "queryForm",
            relation: "AND",
            operation: this.getOperation(key)
          })
        }
      })
      if (this.defKey) {
        queryies.push({
          property: "bpm_pro_inst.proc_def_key_",
          value: this.defKey,
          operation: "EQUAL",
          relation: "AND",
        });
      }
      return queryies;
    },
    getOperation(property){
      for(let key in this.searchOperation){
        if(this.searchOperation[key].includes(property)){
          return key;
        }
      }
    },
    getSorter(){
        return [{
        property:"-IS_READ_",
        direction:"DESC"
      },{
        property:"bpm_task_notice.CREATE_TIME_",
        direction:"DESC"
      },]
    },
    tableRowClass(rows){
      if(rows.row.topnum){
        return 'row-class';
      }
      return 'todo-row';
    }
  },
  created() {
    //页面高度设置
    window.addEventListener('resize', this.getHeight);
    this.getHeight();
    
    let querys = [];
    if (this.defKey) {
      querys.push({
        property: "bpm_pro_inst.proc_def_key_",
        value: this.defKey,
        operation: "EQUAL",
        relation: "AND",
      });
    }
    let sorter = [{
      property:"-IS_READ_",
      direction:"DESC"
    },{
      property:"bpm_task_notice.CREATE_TIME_",
      direction:"DESC"
    },]
    let pageBean = {
      pageBean: { page: "1", pageSize: "20", showTotal: "true" },
      querys,
      sorter
    }; //初次加载默认pageBean
    this.$store
      .dispatch("storeProcess/getNoticeTodoReadList", pageBean)
      .then(() => {
        //页面加载调用tudo.js里面的分页方法
        this.fullscreenLoading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

.el-table /deep/ tr.row-class{
  font-size: 12px;
  color: $--color-text-regular;
  height: 48px;
  background-color: #eee;
}

  /deep/ .el-badge__content.is-dot{
    margin-top: 10px !important;
    margin-right: 8px !important;
    width: 6px !important;
    height: 6px !important;
  }

.el-badge{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
}

/deep/ .search_form_label{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #52535E;
}

/deep/ .el-footer{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  padding: 16px 0px !important;
  span,.el-pagination__total,.el-pagination__jump{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager li,.el-input__inner{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager .active{
    color: #1890FF !important;
  }
} 

/deep/ .el-table::before{
  display: none;
}

/deep/ .el-table--group::after, .el-table--border::after{
  display: none;
}

.el-table--group, .el-table--border{
  border: 0px !important;
}


/deep/ .el-table__body-wrapper{
  // height: 90% !important;
  overflow:auto !important;
}
/deep/.el-table--border th{
  background: #F0F2F5;
  height: 48px;
  line-height: 48px;
  text-align: left;
  color: #000000;
  font-size: 14px;
}

/*
//隔行变色
/deep/.el-table--border tr:nth-child(even){
    background: rgb(240, 241, 241);
}
*/
//移入变色
/deep/.el-table--border tr:hover > td{
    // background-color:#fdfdaf !important;
    background-color:#EDF6FB !important;
    .todo-subject{
      color: #1890FF !important;
    }
    .todo-subject-read{
      color: #1890FF !important;
    }
}

/deep/.el-table--border th,
/deep/.el-table--border td {
  padding: 0px !important;
  border-top: 0px solid #F0F2F5 !important;
  border-bottom: 1px solid #F0F2F5 !important;
  border-left: 0px solid #F0F2F5 !important;
  border-right: 0px solid #F0F2F5 !important;
}



/deep/.el-table--medium th,
/deep/ .el-table--medium td {
  padding: 1px 0;
}



/deep/.el-table .cell{
  padding-left:16px;
  padding-right:0px;
  // line-height: unset;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
}
/deep/.todo-subject,/deep/.el-tooltip>span{
  font-size: 12px !important;
}
.el-table /deep/ tr.todo-row {
  font-size: 12px;
  color: $--color-text-regular;
  height: 48px;
  line-height: 48px;
}
.navbar-collapse{
  display: none;
}


.el-container {
  background-color: #fff;
  padding: 0px;
}

.el-row {
  margin-bottom: 10px;
}

.el-header {
  border-bottom: 0px solid #ededed;
}

.todo-subject {
  cursor: pointer;
}
/deep/.el-button {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}
.todo-subject {
  color: $--theme-color;
}
.top-title {
  line-height: 58px;
  margin-left: 20px;
  font-size: 16px;
  color: #a2a2a2;
}
/deep/.el-tree {
  position: relative;
  cursor: default;
  background: #fff;
  color: $--color-text-primary;
  font-size: 13px;
}
.todo_read_content {
  padding: 0px;
}
/deep/.el-pagination {
  text-align: justify;
  margin: 0 auto;
  font-family: "微软雅黑", "宋体", Arial, sans-serif !important;
  font-size: 12px !important;
}
/deep/.pagination {
  margin-left: 0px;
  margin-top: 0px;
  text-align: left;
  font-family: "微软雅黑", "宋体", Arial, sans-serif;
  font-size: 12px !important;
}
.content_top_wrap {
  display: flex;
  flex-direction: row;
  margin:0px 0 8px 0px;
  /deep/ .el-input__prefix,
  /deep/.el-input__suffix {
    height: 32px;
  }
  /deep/.el-date-editor--datetimerange.el-input__inner {
    width: 220px;
  }
  .done_read_btn {
    margin-right: 10px;
  }
  .date_wrap {
    display: flex;
    p {
      width: 54px;
      margin: 8px;
    }
  }
}
.search_form_label{
  display: block;
  margin-top: 5px;
  float: left;
  width: 15%;
}
.search_input{
  width: 80%;
}
</style>
